import { render, staticRenderFns } from "./ProductColorsList.vue?vue&type=template&id=d89f064a&scoped=true&"
import script from "./ProductColorsList.vue?vue&type=script&lang=js&"
export * from "./ProductColorsList.vue?vue&type=script&lang=js&"
import style0 from "./ProductColorsList.vue?vue&type=style&index=0&id=d89f064a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89f064a",
  null
  
)

export default component.exports